var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditorBold = function SvgEditorBold(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.25 11.8A3.68 3.68 0 0 0 17 9a3.93 3.93 0 0 0-3.86-4H6.65v14h7a3.74 3.74 0 0 0 3.7-3.78v-.12a3.64 3.64 0 0 0-2.1-3.3M8.65 7h4.2a2.09 2.09 0 0 1 2 1.3 2.09 2.09 0 0 1-1.37 2.61q-.309.09-.63.09h-4.2zm4.6 10h-4.6v-4h4.6a2.09 2.09 0 0 1 2 1.3 2.09 2.09 0 0 1-1.37 2.61q-.309.09-.63.09"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditorBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/editor_bold.d39ec878763d606cf07a5085bf41481a.svg";